import { Box, CardContent, Link, Typography, styled, CircularProgress } from "@mui/material";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTheme } from '../../theme/theme-provider';

const StyledCard = styled(Box)({
  display: "flex",
  justifyContent: "center",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover",
  height: 300,
  backgroundColor: '#2a2a2a',
  borderRadius: 6,
  transition: 'opacity 180ms ease, transform 180ms ease, box-shadow 180ms ease, filter 180ms ease',
});

const Card = ({ cardImageId, cardTitle, cardSlug, cardMeta, compact = false }) => {
  const [loaded, setLoaded] = useState(false);
  const { theme, themeMode } = useTheme();
  const titleColor = themeMode === 'dark' ? 'rgba(255,255,255,0.95)' : '#1a1a1a';
  const metaColor = themeMode === 'dark' ? 'rgba(255,255,255,0.72)' : 'rgba(0,0,0,0.68)';
  const hasValidSlug = typeof cardSlug === 'string' && cardSlug.trim() !== '' && cardSlug !== 'undefined' && cardSlug !== 'null';
  const hasValidImageId = cardImageId !== undefined && cardImageId !== null && `${cardImageId}` !== 'undefined' && `${cardImageId}` !== 'null';
  const detailTo = hasValidSlug && hasValidImageId ? `/release/${cardSlug}-${cardImageId}` : '/';

  const imageUrl = cardImageId
    ? `${process.env.REACT_APP_API_URL}/public-image/${cardImageId}`
    : null;

  return (
    <Box
      sx={{
        borderRadius: '10px',
        overflow: 'hidden',
        backgroundColor: theme.surface,
        border: `1px solid ${theme.border}`,
        boxShadow: theme.elevation[2],
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Link
        component={RouterLink}
        to={detailTo}
        sx={{ textDecoration: "none", display: 'flex', flexDirection: 'column', flex: 1 }}>
        {/* Hidden img to fire onLoad — no blob fetch, just native browser loading */}
        {imageUrl && (
          <img
            src={imageUrl}
            onLoad={() => setLoaded(true)}
            onError={() => setLoaded(true)}
            style={{ display: 'none' }}
            alt=""
          />
        )}
        {!loaded
          ? <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: compact ? 'auto' : 300, aspectRatio: compact ? '1' : 'auto', backgroundColor: themeMode === 'dark' ? '#2a2a2a' : 'rgba(223,214,204,0.9)' }}>
              <CircularProgress sx={{ color: themeMode === 'dark' ? '#F2D399' : '#2f4c4c' }} />
            </Box>
          : <StyledCard
              sx={{
                backgroundImage: `url(${imageUrl})`,
                height: compact ? 'auto' : 300,
                aspectRatio: compact ? '1' : 'auto',
                '&:hover': {
                  opacity: 0.86,
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 22px rgba(0, 0, 0, 0.35)',
                  filter: 'saturate(1.05) contrast(1.02)'
                }
              }} />
        }
        <CardContent
          sx={{
            backgroundColor: theme.surface,
            borderTop: `1px solid ${theme.border}`,
            p: { xs: '10px !important', sm: '12px !important', md: '16px !important' },
          }}
        >
          <Typography
            gutterBottom
            variant="body1"
            align="center"
            component="div"
            color={titleColor}
            sx={{ fontFamily: '"Courier New", monospace', fontWeight: 700, fontSize: { xs: '0.72rem', sm: '0.82rem', md: '0.95rem' }, mb: 0.25 }}>
            {cardTitle}
          </Typography>
          <Typography gutterBottom variant="body2" align="center" component="div" color={metaColor} sx={{ fontFamily: '"Courier New", monospace', fontWeight: 600, fontSize: '0.7rem', letterSpacing: '0.05em', textTransform: 'uppercase', minHeight: '1.4em' }}>
            {cardMeta || ''}
          </Typography>
        </CardContent>
      </Link>
    </Box>
  );
};

export default Card;